function Contact() {
  return (
    <div className="page">
      <h1>Contact Me</h1>
      <p>Email: darsanar1420@example.com</p>
      <p>Location: Alappuzha,Kerala, India</p>
    </div>
  );
}

export default Contact;